export class CartaPorteDetalle {
  DETAIL_ID: number;
  index: number;
  ITEM_ID: number;
  HAZARDOUS_MATERIAL_ID: number;
  UNIT_MEASURE_ID: number;
  COMMENTS: any;
  UNIDAD_PESO_ID: number;
  UNIDAD_PESO_ID_SR:number;
  DRIVER_ID:number;
  EMBALAJE_ID_SR:number;
  MONEDA_ID_SR:number;
  MATERIALPELIGROSO_ID_SR:number;

  // ------------- Detalle Peso Carga -----------------
  PESO_BRUTO_TOTAL_DPC: any;
  PRODUCTO_DPC: any;
  UNIDAD_PESO_DPC: any;
  PESO_NETO_DPC: any;
  cantidad_DPC: any;
  satID:any;
  IdOrigen_DPC:any
  IdOrigen_DPC_id:number
  IdDestino_DPC:any;
  IdDestino_DPC_id:number;
  Cargo_Tasacion_DPC: any;
  DIMENSIONES_DPC: any;
  MATERIALPELIGROSO_DPC: any;
  CLAVEMATERIALPELIGROSO_DPC: any;
  CLAVEMATERIALPELIGROSO_DPC_aux:any;
  EMBALAJE_DPC:any;
  BILL_UNIT_MEASURE_ID: any;
  NET_WEIGHT: any;
  QUANTITY: any;
  CHARGE: any;
  GROSS_WEIGHT: any;
  satID_id:number;
  ITEM_SAT_ID:number;
  EMBALAJE_DPC_id:number;
  MATERIALPELIGROSO_DPC_id:number;
  CLAVEMATERIALPELIGROSO_DPC_id:any;
 

  //----------Servicos 
  BIENES_TRASPORTADOS_SR: any
  CLAVE_STC_SR: any
  DESCRIPCION_SR: any
  CANTIDAD_SR: any
  CLAVEUNIDAD_SR: any
  UNIDAD_SR: any
  DIMENSIONES_SR: any
  MATERIALPELIGROSO_SR: any
  CLAVEMATERIALPELIGROSO_SR: any
  EMBALAJE_SR: any
  DESCRIPCIONEMBALAJE_SR: any
  PESO_KG_SR: any
  VALOR_MERCANCIA_SR: any
  MONEDA_SR: any
  FRACCION_ARANCELARIA_SR: any
  UUID_SR: any
  AMOUNT:any;
  PRODUCTO_CONTROL_SR: any
  PRODUCTO_SR: any

  
  //----------Ubicacion 
  UBICACIONES_UBICACION: any;
  UBICACIONES_UBICACION_number: any;
  TIPO_UBICACION_opcion: any;
  TIPO_UBICACION: any;
  RFC_UBICACION: any;
  FECHAHORA_UBICACION: any;
  SALIDALLEGADA_UBICACION: any;
  DISTANCIA_RECORRIDA_UBICACION: any;
  PAIS_UBICACION: any;
  C_LOCALIDAD: number;
  C_LOCALIDAD_Value:any;
  CP_UBICACION: any;
  ESTADO_UBICACION: any;
  MUNICIPIO_UBICACION: any;
  COLONIA_UBICACION: any;
  CALLE_UBICACION: any;
  NUM_EXTERIO_UBICACION: any;
  NUM_INTERIOR_UBICACION: any;
  REFERENCIA_UBICACION: any;
  CITY_ID_Ubicaciones: number;
  BILL_CARTA_PORTE_TYPE:any;
  ID_origendestino:string;


  //----------trasporte 
  OPERADOR_T: any;
  NUMERO_LICENCIA_TPE: any;
  RFC_FIGURA_TPE: any;
  PAIS_TPE: any;
  CITY_ID_TPE: any;
  CP_FIGURA_TPE: any;
  MUNICIPI_TPE: any;
  ESTADO_TPE: any;
  COLONIA_TPE: any;
  CALLE_TPE: any;
  NUM_EXTERIOR_TPE: any;
  NUM_INTERIOR_TPE: any;
  REFERENCIA_TPE: any;
  idunidad : any;
  TIPO_TPE:any;
  TIPO_Name_TPE:any;
  UNIDAD_PESO: any;

  idCartaPorte: string;


  BILL_CARTA_PORTE_ID: number;
  BILL_CARTA_PORTE_WEIGHT_DETAIL_ID: number;
  BILL_CARTA_PORTE_ADDRESS_ID: number;
  NAME_PRODUCT:any;
  }


// WEBPACK FOOTER //
// ./src/app/models/cartaPorte.ts